<!-- qstnid is seq+1-->

<span class="small text-muted" >qstn status </span>
<div class="row bg-pink  align-center"> 
    <div  *ngFor="let q of qstnList;let i= index" class="mx-2 col-01" >
  
   <button [ngClass]="{'bg-primary':color(q) =='primary','bg-warning':color(q) =='orange'}" (click) = 'changeQstn(q,i)' class="rounded-pill" >  {{qs.formatSeq(q.sequence,q.subSeq,q.part)}} </button>
   
</div>
</div>